export const getOptionImages = ({ optionIndex, variants, images }) => {
	const optionValueImagesMap = {}
	const optionKey = `option${optionIndex + 1}`

	variants.forEach((variant) => {
		if (variant[optionKey] && !optionValueImagesMap[variant[optionKey]]) {
			const variantImageId =
				variant.image_id || variant.media?.nodes?.[0]?.id
			const image = images.find((image) => image.id === variantImageId)
			if (image) {
				optionValueImagesMap[variant[optionKey]] = image.src
			}
		}
	})

	return optionValueImagesMap
}
